<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M23 5H9a2 2 0 00-2 2v18a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2zM9 7h14v14H9zm0 18v-3h14v3z"/><path d="M16.35 23.15a.36.36 0 00-.16-.11.49.49 0 00-.54.11.47.47 0 00-.15.35.41.41 0 000 .19.36.36 0 00.11.16.45.45 0 00.39.15.41.41 0 00.19 0 .53.53 0 00.27-.27.41.41 0 000-.19.43.43 0 000-.19.36.36 0 00-.11-.2z"/></svg>